@use './text-field.mixins' as mixins;
@use './text-field.vars' as *;

:host {
  display: flex;
  flex-direction: column;

  @include mixins.text-field-text;
}

@include mixins.text-field-label;
@include mixins.text-field-input;
@include mixins.text-field-description;
